/** @jsx jsx */
import { jsx, Container } from 'theme-ui';
import React, { FunctionComponent } from 'react';

// Assets
import StarIcon from '../../../static/assets/icons/outlined/other/other/star.svg';

// Styles
import * as style from './style';

interface StarRatingProps {
  amount: number;
}

const StarRating: FunctionComponent<StarRatingProps> = ({ amount }) => {
  let content: React.ReactNode[] = [];

  for (let i = 0; i < amount; i += 1) {
    content = [
      ...content,
      <StarIcon sx={style.FilledStar} key={`filled-star-${i}`} />,
    ];
  }

  for (let i = 5 - amount; i > 0; i -= 1) {
    content = [...content, <StarIcon key={`unfilled-star-${i}`} />];
  }

  return <Container sx={style.Container}>{content}</Container>;
};

export default StarRating;
